/* FL Boxy — Boxomat (sections/fl-boxy-slot.liquid): trzy bębny ze wszystkimi boxami kolekcji.
   Losowanie spośród wszystkich boxów (nigdy dwa razy z rzędu ten sam); bębny zwalniają z lekkim
   przestrzałem i stają na wylosowanym boxie. Wynik = karta z <template data-card> (ta sama co na półce). */
(() => {
  'use strict';

  if (customElements.get('fl-boxy-slot')) return;

  const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const shortName = (t) => String(t || '').replace(/\s*box$/i, '').trim() || String(t || '');
  const CONFETTI = ['#62A807', '#FF8009', '#E30814', '#FFD23F', '#5BC8F5', '#1F7AD6'];

  class FLBoxySlot extends HTMLElement {
    connectedCallback() {
      if (!this.ready) this.init();
      if (!this.boxes.length) return;
      window.addEventListener('resize', this.onResize);
      if (this.built) {
        this.layoutReels();
        return;
      }
      if ('IntersectionObserver' in window) {
        this.near = new IntersectionObserver((entries) => {
          if (entries.some((x) => x.isIntersecting)) {
            this.buildReels();
            this.near.disconnect();
          }
        }, { rootMargin: '900px 0px' });
        this.near.observe(this);
      } else {
        this.buildReels();
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.onResize);
      if (this.near) this.near.disconnect();
    }

    init() {
      this.ready = true;
      let data = [];
      try {
        const src = this.querySelector('script[data-boxy-data]');
        data = JSON.parse(src ? src.textContent : '[]');
      } catch (e) {
        data = [];
      }
      this.boxes = (Array.isArray(data) ? data : []).filter((b) => b && b.id != null);
      this.spinBtn = this.querySelector('.fl-boxy-slot__spin');
      this.result = this.querySelector('.fl-boxy-slot__result');
      this.live = this.querySelector('[data-live]');
      const noimg = this.querySelector('template[data-noimg]');
      this.noimg = noimg ? noimg.innerHTML : '';
      this.reels = [...this.querySelectorAll('.fl-boxy-slot__reel')].map((el) => ({ el, strip: el.querySelector('.fl-boxy-slot__strip'), pos: 0 }));
      this.R = Math.max(8, Math.ceil(48 / Math.max(this.boxes.length, 1)));
      this.built = false;
      this.spinning = false;
      this.last = null;
      this.onResize = () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => { if (this.built && !this.spinning) this.layoutReels(); }, 120);
      };
      if (!this.spinBtn) return;
      if (!this.boxes.length || !this.reels.length) {
        this.spinBtn.disabled = true;
        return;
      }
      this.spinBtn.addEventListener('click', () => this.spin());
      // CSS sekcji niżej na stronie dociąga się asynchronicznie — po nim przelicz położenie bębnów.
      window.addEventListener('load', () => { if (this.built && !this.spinning) this.layoutReels(); }, { once: true });
    }

    tileHTML(b) {
      const media = b.img
        ? `<img src="${esc(b.img)}" width="${Number(b.w) || 400}" height="${Number(b.h) || 400}" alt="" decoding="async">`
        : this.noimg;
      return `<div class="fl-boxy-slot__cell"><div class="fl-boxy-slot__tile" style="${esc(b.vars)}">${media}<span>${esc(shortName(b.title))}</span></div></div>`;
    }

    geom(r) {
      const c = r.strip.firstElementChild;
      const cell = c ? c.getBoundingClientRect().height : 0;
      return { cell, off: (r.el.clientHeight - cell) / 2 };
    }

    yAt(g, p) {
      return `translate3d(0,${(g.off - p * g.cell).toFixed(1)}px,0)`;
    }

    layoutReels() {
      if (!this.built) return;
      this.reels.forEach((r) => { r.strip.style.transform = this.yAt(this.geom(r), r.pos); });
    }

    buildReels() {
      if (this.built) return;
      const N = this.boxes.length;
      const cells = this.boxes.map((b) => this.tileHTML(b)).join('').repeat(this.R);
      this.reels.forEach((r, k) => {
        r.strip.innerHTML = cells;
        r.pos = ((k * 2 + 1) % N) + N * (this.R - 4);
      });
      this.built = true;
      this.layoutReels();
    }

    say(text) {
      if (!this.live) return;
      this.live.textContent = '';
      setTimeout(() => { this.live.textContent = text; }, 60);
    }

    confetti() {
      const wrap = document.createElement('div');
      wrap.className = 'fl-boxy-slot__confetti';
      wrap.setAttribute('aria-hidden', 'true');
      let html = '';
      for (let i = 0; i < 22; i += 1) {
        const a = (i / 22) * Math.PI * 2 + Math.random() * 0.3;
        const d = 90 + Math.random() * 120;
        html += `<i style="--x:${(Math.cos(a) * d).toFixed(0)}px;--y:${(Math.sin(a) * d - 50).toFixed(0)}px;--rot:${(Math.random() * 540 - 270).toFixed(0)}deg;--k:${CONFETTI[i % CONFETTI.length]};--d:${(Math.random() * 120).toFixed(0)}ms"></i>`;
      }
      wrap.innerHTML = html;
      this.result.appendChild(wrap);
      setTimeout(() => wrap.remove(), 1400);
    }

    // Wynik to ta sama karta co na półce (szablon renderuje Liquid).
    showResult(b, fx) {
      if (!this.result) return;
      const tpl = [...this.querySelectorAll('template[data-card]')].find((t) => t.dataset.card === String(b.id));
      const hitText = this.dataset.hitText || '';
      this.result.replaceChildren();
      if (hitText) {
        const hit = document.createElement('p');
        hit.className = 'fl-boxy-sticker fl-boxy-slot__hit';
        hit.textContent = hitText;
        this.result.appendChild(hit);
      }
      if (tpl) this.result.appendChild(document.importNode(tpl.content, true));
      const card = this.result.querySelector('.fl-boxy-card');
      if (fx && card) {
        card.classList.add('is-landing');
        this.confetti();
      }
      const lead = this.dataset.liveText || '';
      this.say(`${lead} ${b.title}${b.sub ? `: ${b.sub}` : ''}.`.trim());
      const top = this.result.getBoundingClientRect().top;
      if (top > window.innerHeight * 0.72) window.scrollBy({ top: top - window.innerHeight * 0.2, behavior: 'smooth' });
    }

    spin() {
      if (this.spinning) return;
      this.buildReels();
      const N = this.boxes.length;
      let t = 0;
      if (N > 1) {
        do { t = Math.floor(Math.random() * N); } while (this.boxes[t] === this.last);
      }
      const target = this.boxes[t];
      const R = this.R;
      this.spinning = true;
      this.last = target;
      this.classList.add('is-spinning');
      this.spinBtn.setAttribute('aria-disabled', 'true');
      const runs = this.reels.map((r, k) => {
        const g = this.geom(r);
        const loops = Math.max(3, Math.ceil(10 / N)) + k;
        const start = (r.pos % N) + N * (R - 2);
        const end = t + N * (R - 2 - loops);
        r.pos = end;
        r.strip.style.transform = this.yAt(g, end);
        if (typeof r.strip.animate !== 'function' || !g.cell) return Promise.resolve();
        const over = `translate3d(0,${(g.off - end * g.cell + g.cell * 0.14).toFixed(1)}px,0)`;
        return r.strip.animate([
          { transform: this.yAt(g, start), easing: 'cubic-bezier(.15,.6,.3,1)' },
          { transform: over, offset: 0.88, easing: 'ease-in-out' },
          { transform: this.yAt(g, end) }
        ], { duration: 1300 + k * 480 }).finished.catch(() => {});
      });
      Promise.all(runs).then(() => {
        this.spinning = false;
        this.classList.remove('is-spinning');
        this.spinBtn.removeAttribute('aria-disabled');
        this.showResult(target, true);
      });
    }
  }

  customElements.define('fl-boxy-slot', FLBoxySlot);
})();
